var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"settings"},[_c('header-widget'),_c('h2',[_vm._v("Настройки")]),_c('topbar-settings'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }